import { Card, List, Space, Typography } from 'antd';
import React, { memo, useContext, useMemo } from 'react';
import TagIcon from '../../knowledge-base-common/components/tag-icon';
import { SearchResult, Tag } from '../knowledge-base.type';
import ArticleStatistics from './article-statistics';
import { localize } from '/react4xp/mixins/helpers';
import { ComponentContext } from '/react4xp/parts/knowledge-base/knowledge-base';

type SearchResultsViewProps = {
    query: string;
    articles: SearchResult[];
    tags: Tag[];
};

type Article = SearchResult & {
    coincidenceCount: number;
};

const SearchResultsView = memo(({ query, articles, tags }: SearchResultsViewProps) => {
    const { clientUrl, translations } = useContext(ComponentContext);

    const getCoincidenceCount = (article: SearchResult): number => {
        return ((article.content + article.title).match(new RegExp(query, 'gi')) || []).length;
    };

    const groupedByTagIdArticles = useMemo(() => {
        const grouped = articles.reduce((acc, data) => {
            const article: Article = {
                ...data,
                coincidenceCount: getCoincidenceCount(data),
            };

            if (!acc[article.tagId]) {
                acc[article.tagId] = [];
            }
            acc[article.tagId].push(article);
            return acc;
        }, {} as Record<string, Article[]>);

        return Object.entries(grouped).map(([tagId, articles]) => ({
            tagId,
            articles,
        }));
    }, [articles]);

    return (
        <>
            <p
                className="title"
                style={{ marginBottom: '1rem' }}
            >
                {localize('search-results', translations)}: <u>{query}</u>
            </p>

            {articles.length === 0 && (
                <Card>
                    <Typography>
                        <Typography.Paragraph>
                            {localize(
                                'knowledge-base.system-no-results-message',
                                translations
                            ).replace('__QUERY__', query)}
                        </Typography.Paragraph>
                        <Typography.Paragraph strong>
                            {localize('knowledge-base.recommendations', translations)}
                        </Typography.Paragraph>
                        <List
                            size="small"
                            dataSource={[
                                localize('knowledge-base.rec-1', translations),
                                localize('knowledge-base.rec-2', translations),
                                localize('knowledge-base.rec-3', translations),
                            ]}
                            renderItem={(item) => <List.Item>{item}</List.Item>}
                        />
                    </Typography>
                </Card>
            )}

            <Space
                direction="vertical"
                style={{ display: 'flex' }}
            >
                {groupedByTagIdArticles.map(({ tagId, articles }) => {
                    const tag = tags.find((t) => t.id === tagId);

                    return (
                        <Card
                            key={tagId}
                            title={
                                <Space>
                                    <TagIcon
                                        name={tag.icon}
                                        size={20}
                                    />
                                    <p style={{ margin: 0 }}>{tag.title}</p>
                                </Space>
                            }
                        >
                            <List
                                dataSource={articles}
                                renderItem={(article) => {
                                    return (
                                        <List.Item>
                                            <Card variant="borderless">
                                                <ArticleStatistics
                                                    published={article.updatedAt}
                                                    views={article.views}
                                                    coincidenceCount={article.coincidenceCount}
                                                />
                                                <a
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={`${clientUrl}?article=${article.id}`}
                                                    className="title"
                                                    style={{ display: 'block', padding: '1rem 0' }}
                                                >
                                                    {article.title}
                                                </a>
                                                <p
                                                    className="article-content"
                                                    dangerouslySetInnerHTML={{
                                                        __html: article.content,
                                                    }}
                                                />
                                            </Card>
                                        </List.Item>
                                    );
                                }}
                            />
                        </Card>
                    );
                })}
                {/* {articles.map((article) => {
                    const tag = tags.find((t) => t.id === article.tagId);

                    const coincidenceCount = useMemo(() => {
                        return (
                            (article.content + article.title).match(new RegExp(query, 'gi')) || []
                        ).length;
                    }, [article]);

                    return (
                        <Card
                            key={article.id}
                            title={
                                <Space>
                                    <TagIcon
                                        name={tag.icon}
                                        size={20}
                                    />
                                    <p style={{ margin: 0 }}>{tag.title}</p>
                                </Space>
                            }
                        >
                            <ArticleStatistics
                                published={article.updatedAt}
                                views={article.views}
                                coincidenceCount={coincidenceCount}
                            />
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`${clientUrl}?article=${article.id}`}
                                className="title"
                                style={{ display: 'block', padding: '1rem 0' }}
                            >
                                {article.title}
                            </a>
                            <p
                                className="article-content"
                                dangerouslySetInnerHTML={{
                                    __html: article.content,
                                }}
                            />
                        </Card>
                    );
                })} */}
            </Space>
        </>
    );
});

export default SearchResultsView;
